// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getMonth as fn } from "../getMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getMonth = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getMonth;
